export const LOGIN_LIMIT_REMINDER_ALERT_ID = "LOGIN_LIMIT_REMINDER_ALERT";

export interface LoginLimitReminderData {
	loginsMade?: number;
	currentLoginLimit?: number;
}
